import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { FormGroup, Input, Row, Col, Button } from "reactstrap";

// helpers
import { showMessage } from "../../../helpers/message";
import { getSessionCookie } from "../../../helpers/cookies";
import { formateDateApi } from "../../../helpers/formats.js";

// api
import analiseboletim_api from "../../../api/analiseboletim_api.js";
import boletimvistoria_api from '../../../api/boletimvistoria_api';

export default function PedidoVista({ boletimVistoria, setshowLoading, handleReturn }) {

    const { register, getValues } = useForm({ mode: "onBlur" });

    const session = getSessionCookie();

    const handleSolicitarPedidoVistas = () => {
        let json_submit = {
            boletimVistoriaPedidoVista_Id: 0,
            boletimVistoria_Id: boletimVistoria.boletimVistoria_Id,
            dataHora: formateDateApi(new Date()),
            usuario_Id: session.usuario_Id,
            status: "Pendente",
            url: ""
        }

        setshowLoading(true);
        analiseboletim_api.postPedidoVistas(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', null);
                return;
            }
        })
    }

    const [boletimVistoriaItem, setboletimVistoriaItem] = useState(null);
    useEffect(() => {
        if (boletimVistoria != null)
            setboletimVistoriaItem(boletimVistoria);
    }, []);

    const handleEnviarPedidoVistas = () => {
        let data = getValues();

        let { boletimVistoriaPedidoVista } = boletimVistoriaItem;
        
        let json_submit = {
            boletimVistoriaPedidoVista_Id: boletimVistoriaPedidoVista.boletimVistoriaPedidoVista_Id,
            boletimVistoria_Id: boletimVistoriaItem.boletimVistoria_Id,
            dataHora: formateDateApi(new Date()),
            usuario_Id: session.usuario_Id,
            url: data.urlProcesso,
            status: "Enviado"
        }

        setshowLoading(true);
        analiseboletim_api.putPedidoVistas(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                boletimvistoria_api.getItem(boletimVistoriaItem.boletimVistoria_Id).then(result => {
                    if (result.status !== 200) {
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else {
                        setboletimVistoriaItem(result.data);
                        showMessage("Aviso", "Operação executada com sucesso!", 'success', null);
                        return;
                    }
                })
            }
        })
    }

    return (
        <>
            <h5 className="subtitleCardInfo">Pedido de Vistas</h5>
            {boletimVistoriaItem && boletimVistoriaItem.boletimVistoriaPedidoVista != null &&
                <Row className="mb-4">
                    <Col lg="12" md="12" sm="12">
                        <strong>Status: </strong>{boletimVistoriaItem.boletimVistoriaPedidoVista.status}
                    </Col>
                    {boletimVistoriaItem.boletimVistoriaPedidoVista.status == "Enviado" &&
                        <Col lg="12" md="12" sm="12">
                            <strong>URL: </strong><a target="_blank" href={boletimVistoriaItem.boletimVistoriaPedidoVista.urL_PedidoVistas}>{boletimVistoriaItem.boletimVistoriaPedidoVista.urL_PedidoVistas}</a>
                        </Col>
                    }
                </Row>
            }
            {boletimVistoriaItem && boletimVistoriaItem.boletimVistoriaPedidoVista == null && (session.perfil == "Concessionária" || session.perfil == "Administrador") &&
                <Row className="mb-4">
                    <Col lg="12" md="12" sm="12">
                        <Button color="success" onClick={() => handleSolicitarPedidoVistas()}>Solicitar de Pedido Vistas</Button>
                    </Col>
                </Row>
            }
            {boletimVistoriaItem && boletimVistoriaItem.boletimVistoriaPedidoVista != null && boletimVistoriaItem.boletimVistoriaPedidoVista.status == "Pendente" &&
                (session.perfil == "Gestor" || session.perfil == "Administrador") &&
                <Row className="mb-4">

                    <Col lg="12" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">URL do Processo</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="urlProcesso"
                                innerRef={register({ required: false })}
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12">
                        <Button color="success" onClick={() => handleEnviarPedidoVistas()}>
                            Enviar
                        </Button>
                    </Col>
                </Row>
            }
        </>
    );
}
